<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  فروش رمز ارز 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <template v-if="step === 1">
                  <div class="m-auto" style="max-width:400px;">

                    <div @click="crypto_list_modal = true" class="magic-input-box" style="cursor:pointer;">
                      <div class="magic-input">
                        <input disabled v-model="form.paid_currency" placeholder="انتخاب رمز ارز">
                      </div>
                      <div class="magic-titr">
                        <div class="i mdi mdi-chevron-down"></div>
                      </div>
                    </div>

                    <div class="magic-input-box">
                      <div class="magic-input">
                        <input @input="changeAmount()" :disabled="!form.paid_currency" v-model="form.paid_amount" placeholder="مقدار">
                      </div>
                      <div class="magic-titr p-2">
                        <img v-if="form.paid_currency" :src="StaticImageUrl+'assets/images/icon/'+ form.paid_currency +'USDT.png'" style="height: 40px;margin: auto;">
                      </div>
                    </div>
                    
                    <div class="magic-input-box">
                      <div class="magic-input">
                        <input disabled v-model="form.toman_receive" placeholder="معادل تومان">
                      </div>
                      <div class="magic-titr p-2">
                        تومان
                      </div>
                    </div>
                    
                    <div class="magic-input-box">
                      <div class="magic-input">
                        <input disabled v-model="form.tether_receive" placeholder="معادل تتر">
                      </div>
                      <div class="magic-titr p-2">
                        تتر
                      </div>
                    </div>

                    <div class="text-center text-primary-dark py-3" v-if="wallet_not_found">
                      متاسفانه امکان فروش این ارز وجود ندارد.
                    </div>

                    
                    <div class="text-center">
                      <button v-if="!form.paid_amount || !form.paid_currency || Object.entries(wallet).length === 0" class="ar-btn size-xl round primary disabled">ادامه</button>
                      <button v-else class="ar-btn size-xl round primary" @click="step = 2">ادامه</button>
                    </div>

                  </div>
                </template>
                <template v-if="step === 2">
                    
                  <div class="row">
                    <div class="col-lg-12 col-sm-12 pt-3 text-primary-dark">
                      
                      <div class="ar-form-group">
                        <div class="text-center py-1">
                          <add-bank-account>
                            <button class="ar-btn size-xs primary round">افزودن کارت بانکی <i class="mdi mdi-plus"></i></button>
                          </add-bank-account>
                        </div>
                        <select class="ar-form-control text-center" v-model="form.bank_account_id">
                          <option :value="null" disabled hidden>انتخاب کارت بانکی</option>
                          <option v-for="(item , key) in state_bank_accounts" :key="key" :value="item.id">{{ item.card_number }}</option>
                        </select>
                        <div v-if="errors.bank_account_id" class="ar-form-text">
                          <small>انتخاب کارت بانکی الزامی است.</small>
                        </div>
                      </div>
                      
                      <div>شبکه انتقال را انتخاب کنید.</div>
                      <div class="buy-sell-select-networks">
                        <div v-for="(item , key) in networks" :key="key" class="select-networks-item font-en">
                          <button class="ar-btn size-lg round" :class="[wallet.network === item.network ? 'primary' : 'disabled']" @click="wallet = item">{{ item.network }}</button>
                        </div>
                      </div>
                      
                      <div class="ar-form-group">
                        <label>رمز ارز خود را بر اساس شبکه انتخاب شده به آدرس ولت زیر ارسال نمایید.</label>
                        <div class="ar-form-append">
                          <input disabled class="ar-form-control text-center font-en" v-model="wallet.address">
                          <span class="ar-form-icon popover-activator" tabindex="1" @click="CopyText(wallet.address)">
                            <i class="mdi mdi-content-copy"></i>
                            <span class="ar-popover">
                              کپی شد
                            </span>
                          </span>
                        </div>
                      </div>
                      <div v-if="wallet.qr_code_file" class="text-left">
                        <small class="cp" @click="qr_code_modal = true">نمایش کد QR<i class="mdi mdi-qrcode"></i></small>
                      </div>

                      <div class="ar-form-group">
                        <label>
                          لطفا هش تراکنش را وارد کنید.
                          <i class="mdi mdi-information-outline"></i>
                        </label>
                        <input class="ar-form-control text-center font-en" placeholder="TXID" v-model="form.txid">
                      </div>

                    </div>
                  </div>
                  
                  <div class="text-center">
                    <button class="ar-btn size-md round info mx-3" @click="step = 1">گام قبلی</button>
                    <button v-if="!form.bank_account_id || !form.txid" class="ar-btn size-md round primary disabled">ثبت و ادامه</button>
                    <button v-else class="ar-btn size-md round primary" @click="submitSellReq()">ثبت و ادامه</button>
                  </div>

                </template>

                <template v-if="step === 3">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="ar-card size-sm text-primary-dark">
                        <div class="ar-card-header justify-content-center">
                          <div class="ar-card-title text-danger">فاکتور تایید نشده</div>
                        </div>
                        <div class="ar-card-body">

                          <div class="text-center mb-2">
                            <button class="ar-btn size-sm primary round">فروش رمز ارز</button>
                          </div>
                          
                          <div class="d-flex justify-content-between mb-3">
                            <div>نام فروشنده</div>
                            <div>{{ userData.fullname }}</div>
                          </div>
                          <div class="d-flex justify-content-between mb-3">
                            <div>میزان فروش</div>
                            <div>{{form.paid_amount}} {{ form.paid_currency }} </div>
                          </div>
                          <div class="d-flex justify-content-between mb-3">
                            <div>قیمت هر واحد در لحظه فروش(تتر)</div>
                            <div>{{ form.paid_currency_price }} تتر</div>
                          </div>
                          <div class="d-flex justify-content-between mb-3">
                            <div>قیمت هر واحد در لحظه فروش(تومان)</div>
                            <div v-if="state_prices">{{ formatPrice(form.paid_currency_price * state_prices.buy_price) }} تومان</div>
                          </div>
                          <div class="d-flex justify-content-between mb-3">
                            <div>قیمت هر واحد تتر</div>
                            <div v-if="state_prices">{{ state_prices.buy_price }} تومان</div>
                          </div>
                          <div class="d-flex justify-content-between mb-3">
                            <div>کارمزد مبادله</div>
                            <div class="mx-4">0</div>
                          </div>

                          <div style="background:#E2DEDE;padding:.5rem;border-radius:.5rem">

                            <div class="d-flex justify-content-between">
                              <div>مبلغ دریافتی</div>
                              <div>{{form.toman_receive}} تومان</div>
                            </div>

                          </div>

                          <div>
                            <small class="mt-3">کارمزد شما در این تبادل صفر می باشد.</small>
                          </div>
                          <div><small class="mt-3">این فاکتور صرفا جهت اطلاع شما از جزئیات مبادله نمایش داده می شود و به معنی نهایی بودن مبالغ ثبت شده در این فاکتور نیست.</small></div>
                          <div><small class="mt-3">مبلغ و تایید فاکتور بعد از دریافت رمز ارز و تایید ارزینه نهایی می گردد و در قسمت تاریخچه مبادلات در دسترس است .</small></div>
                          <div><small class="mt-3">بدیهی است مبلغ واریزی به حساب کاربران مبلغ تایید نهایی شده از سمت ارزینه می باشد.</small></div>
                        </div>
                        <div class="ar-card-footer py-2">
                          <div><small class="font-07">تسویه فروش رمز ارز شما بعد از تایید تراکنش و تبدیل به تتر صورت می گیرد.</small></div>
                          <div class="text-center">
                            <button class="ar-btn size-md round primary" @click="reset()">متوجه شدم</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

              </div>
            </div>

            <div v-if="step == 1" class="ar-card mt-3">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تاریخچه  
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <div v-if="!Object.keys(sell_crypto_filter).length" class="p-4 text-center">هنوز درخواستی ایجاد نشده است.</div>

                <div class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>میزان واریزی</th>
                        <th>مقدار دریافتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in sell_crypto_filter" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                            <bdi>{{item.paid_amount}} {{item.paid_currency}}</bdi>
                        </td>
                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-if="item.received_currency == 'IRR'">
                            {{formatPrice(item.received_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">انجام شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                          <span class="text-primary" v-if="item.status == 3">در حال واریز</span>
                          <span class="text-primary" v-if="item.status == 4">در حال واریز</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : ''),
                              (item.status == 3 ? 'text-primary' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>


      <modal @close="crypto_list_modal = false" :open="crypto_list_modal" :maxWitdh="'600px'">
        <div class="ar-card primary">
          <div class="ar-card-header">
            <div class="ar-card-title">
              انتخاب رمز ارز 
            </div>
            <span>
              <i @click="crypto_list_modal = false" class="mdi mdi-close"></i>
            </span>
          </div>
          <div class="ar-card-body text-right" style="max-height: 50vh;overflow: auto;">
            
            <div class="p-3">
              <div class="ar-form-group">
                <input type="text" v-model="crypto_search" class="ar-form-control" placeholder="جست و جو بر اساس نماد">
              </div>
            </div>

            <table class="table ar-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th class="text-right">رمز ارز</th>
                  <th>قیمت</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item , key) in crypto_list" :key="key" @click="changeCurrency(item.symbol , item.markPrice)">
                  <template v-if="item.symbol.endsWith('USDT')">
                    <template v-if="item.symbol.replace('USDT' , '').includes(crypto_search)">
                      <template v-if="
                        !item.symbol.endsWith('BULLUSDT') && 
                        !item.symbol.endsWith('BEARUSDT') && 
                        !item.symbol.endsWith('UPUSDT') && 
                        !item.symbol.endsWith('DOWNUSDT')">

                        <td class="text-light">{{ key + 1 }}</td>
                        <td>
                          
                          <div class="box-item">
                            <div class="img-box"><img :src="StaticImageUrl+'assets/images/icon/'+ item.symbol +'.png'"></div>
                            <div class="coin-txt-box">
                                <p class="prsIcon text-light">{{crypto_currencies[item.symbol]}}</p>
                                <p class="engIcon text-light">
                                  <template v-if="item.symbol">
                                    {{ item.symbol.replace('USDT' , '') }}
                                  </template>
                                </p>
                            </div>
                          </div>
                          
                        </td>
                        <td class="text-light">
                          <template v-if="state_prices">
                            {{ formatPrice(parseFloat(item.markPrice) * state_prices.sale_price)}} تومان

                          </template>
                        </td>

                      </template>
                    </template>
                  </template>
                </tr>
              </tbody>
            </table>
            
          </div>
          <div class="ar-card-footer">
            <button @click="crypto_list_modal = false" class="ar-btn size-sm danger mx-3">بستن</button>
          </div>
        </div>
      </modal>
    
      <modal @close="qr_code_modal = false" :open="qr_code_modal" :maxWitdh="'400px'">
        
        <div class="ar-card">
          <div class="ar-card-header">
            <span></span>
            <div class="ar-card-title">
              اسکن کد QR 
            </div>
            <span>
              <i @click="qr_code_modal = false" class="mdi mdi-close"></i>
            </span>
          </div>
          <div class="ar-card-body text-right">
            <img :src="ImageUrl + wallet.qr_code_file" style="width:100%;height:auto;">
          </div>
          <div class="ar-card-footer text-center">
            <button @click="qr_code_modal = false" class="ar-btn size-sm primary mx-3">تایید</button>
          </div>
        </div>

      </modal>

    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Modal from '../../components/Modal.vue'
import vSelect from 'vue-select'
import {io} from 'socket.io-client';
import AddBankAccount from '../../components/AddBankAccount.vue'
import crypto_currencies from '../../plugins/crypto_currencies'
import HelperNav from './partials/HelperNav'
export default {
  name: 'ConvertCrypto',
  components:{
    Sidebar, Header, Modal, vSelect,
    AddBankAccount,
    HelperNav,
  },
  data : () => ({
    step: 1,
    modal: false,
    success: false,
    payment_data: {},
    form:{
      admin_wallet_id: null,
      bank_account_id: null,
      paid_amount: null,
    },
    crypto_list_modal:false,
    crypto_list:[],
    crypto_search:'',
    crypto:{},
    wallet:{},
    crypto_currencies,
    errors:{},
    networks:[],
    error_text:null,
    qr_code_modal : false,
    crypto_list_loaded : false,
    wallet_not_found : false,
    socket : null,
    histories : [],
  }),
  computed:{
    
    filterSearch() {
      if(this.crypto_search == ''){
        return this.cryptoList
      }else{
        return this.cryptoList.filter( item => {
          if(item.prs){
            const word = this.crypto_search.toUpperCase()
            return item.prs.includes(this.crypto_search) || item.nikeName.includes(word)
          }
        })
      }
    },
    confirmed_bank_accounts()
    {
      const confirmed = this.state_bank_accounts.filter(bank_account => {
        return bank_account.status == 1;
      });

      return confirmed;
    },
    
    sell_crypto_filter() {
      return this.histories.filter( item => {
        return item.paid_currency !== 'USDT'
      })
    },

  },
  watch:{
    crypto_search(){
      this.crypto_search = this.crypto_search.toUpperCase()
    },
    state_bank_accounts(){
      if(this.state_bank_accounts.length){
        this.form.bank_account_id = this.state_bank_accounts[0].id
      }
    }
  },
  methods:{
    changeCurrency(symbol , price)
    {
      this.form.paid_currency = symbol.replace('USDT' , '');
      this.form.paid_currency_price = parseFloat(parseFloat(price).toFixed(6));
      
      this.wallet = {}
      this.form.paid_amount = null
      
      this.form.toman_receive = null;
      this.form.tether_receive = null;
      
      this.getNetworks(symbol);

      this.crypto_list_modal = false;
    },
    changeAmount() {
      if(this.form.paid_amount){
        this.form.paid_amount = this.form.paid_amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
        const toman = parseFloat((this.form.paid_amount * this.state_prices.buy_price) * this.form.paid_currency_price);
        const tether = parseFloat(this.form.paid_amount * this.form.paid_currency_price)
        this.form.toman_receive = this.formatPrice(toman - (toman * 0.001));
        this.form.tether_receive = parseFloat(tether - (tether * 0.001)).toFixed(1);
        this.form.received_amount = parseInt(toman - (toman * 0.001));

      }else{
        this.form.toman_receive = null;
        this.form.tether_receive = null;
      }
    },
    getNetworks (symbol){
      this.$axios.post(`getNetworks` , {symbol:symbol})
      .then(res => {
        this.networks = res.data.data
        if(this.networks[0])
        {
          this.wallet = this.networks[0]
          this.wallet_not_found = false
        }else{
          this.wallet = {}
          this.wallet_not_found = true
        }
      })
      .catch(err => {
      });
    },
    submitSellReq (){
      this.activeLoading(true)
      const api_token = this.getToken()
      this.form.admin_wallet = this.wallet.address
      console.log(this.form);
      this.$axios.post(`submitSellCryptoReq`, this.form ,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.step = 3;
        this.socket.emit('admin_notification');
        this.getHistories()
        this.activeLoading(false)
      })
      .catch(err => {
        this.errors = err.response.data.errors
        this.activeLoading(false)
      });

    },
    reset(){
      this.form = {
        admin_wallet_id: null,
        bank_account_id: null,
        paid_amount: null,
      }
      this.step = 1
    },
    getHistories(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`exchangesHistory`,{type:'sell'},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.histories = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    },
    CopyText(text){
      navigator.clipboard.writeText(text);
    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
    const vm = this
    vm.socket = io(vm.socketUrl);
    vm.socket.emit('live_crypto_list');
    vm.socket.on('live_crypto_list', (data) => {
     
      vm.crypto_list = data
      if(!vm.crypto_list_loaded){
        const symbol = vm.crypto_list[0].symbol
        this.form.paid_currency = symbol.replace('USDT' , '');
        this.form.paid_currency_price = parseFloat(parseFloat(vm.crypto_list[0].markPrice).toFixed(6));
      }

      let btcbusd = vm.crypto_list.find(item => item.symbol === 'BTCBUSD');
      let btcusdt = vm.crypto_list.find(item => item.symbol === 'BTCUSDT');
      let price;
      if(btcbusd && btcusdt)
      {
        price = parseFloat(parseFloat(btcusdt.markPrice) / parseFloat(btcbusd.markPrice)).toFixed(5)
      }

      const busd = {
        symbol:'BUSDUSDT',
        markPrice:price
      }
      vm.crypto_list.push(busd);
      vm.crypto_list_loaded = true

    });
    
    this.getNetworks('BTCUSDT');
    this.getHistories();
  }
}
</script>
<style>
</style>
